/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTemplateResponse
 */
export interface GetTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof GetTemplateResponse
     */
    downloadUrl: string | null;
}

/**
 * Check if a given object implements the GetTemplateResponse interface.
 */
export function instanceOfGetTemplateResponse(value: object): value is GetTemplateResponse {
    if (!('downloadUrl' in value) || value['downloadUrl'] === undefined) return false;
    return true;
}

export function GetTemplateResponseFromJSON(json: any): GetTemplateResponse {
    return GetTemplateResponseFromJSONTyped(json, false);
}

export function GetTemplateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTemplateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'downloadUrl': json['downloadUrl'],
    };
}

export function GetTemplateResponseToJSON(json: any): GetTemplateResponse {
    return GetTemplateResponseToJSONTyped(json, false);
}

export function GetTemplateResponseToJSONTyped(value?: GetTemplateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'downloadUrl': value['downloadUrl'],
    };
}

